import { FC, ReactNode } from 'react';
import { cn } from '../../../util';

type Props = {
  icon: ReactNode;
  label: string;
  value: string;
  subtext: string;
  tone?: 'default' | 'danger';
  /** The coin-growth glyph is drawn smaller than the others. */
  compactIcon?: boolean;
};

export const WalletKpiTile: FC<Props> = ({
  icon,
  label,
  value,
  subtext,
  tone = 'default',
  compactIcon = false
}) => {
  const danger = tone === 'danger';

  return (
    <div
      data-testid="wallet-kpi-tile"
      data-tone={tone}
      className={cn(
        'flex min-w-0 flex-1 flex-col gap-1 rounded-xl p-4 ring-1 ring-inset forced-colors:outline forced-colors:outline-1',
        danger
          ? 'bg-red-50 text-red-600 ring-red-200'
          : 'bg-white text-primary-main ring-primary-100'
      )}
    >
      <div className="flex items-center gap-2">
        <span
          className={cn(
            'flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
            compactIcon ? '[&_svg]:h-5 [&_svg]:w-5' : '[&_svg]:h-6 [&_svg]:w-6',
            danger ? 'bg-red-100' : 'bg-primary-50'
          )}
        >
          {icon}
        </span>
        <span className="text-base">{label}</span>
      </div>
      <span className="text-[30px] font-bold leading-10">{value}</span>
      <span className={cn('min-h-4 text-xs', danger ? 'text-red-400' : 'text-primary-400')}>
        {subtext}
      </span>
    </div>
  );
};
